import { IconButton, Input, SelectPicker } from "rsuite";
import Responsive from "../../../Components/Responsive";
import format_number from "../../../Helpers/number_formatter";
import styles from "./styles/informationsStyles";
import { services, typeExtratUmrah } from "../../../Constants/types";
import PlusRoundIcon from "@rsuite/icons/PlusRound";
import TrashIcon from "@rsuite/icons/Trash";
import { getServiceLabel } from "../../../Helpers/functions";
import Translation from "../../../translation/translation";

const ExtratsForm = ({
  model,
  fetchProviders,
  providers,
  handleUpdateExtrat,
  getCurrencyOptions,
  handleCurrencySelect,
  handleProviderSelect,
  exchange,
  providerId,
  currencyId,
  handleAddExtrats,
  handleRemoveExtrat,
  setModel,
}) => {
  const getAvailableExtrats = (index) => {
    const availableDesignations = getAvailableDesignations(index);
    const hasAvailableDesignations = availableDesignations.length > 0;

    const usedExtrats = model.extrats
      .filter((_, i) => i !== index)
      .map((extrat) => extrat.service);

    return services.filter((option) => {
      if (option.value === 0 && hasAvailableDesignations) return true;
      return !usedExtrats.includes(option.value);
    });
  };

  const getAvailableDesignations = (index) => {
    const usedDesignations = model.extrats
      .filter((extrat, i) => i !== index && extrat.service === 0)
      .map((extrat) => extrat.designation);

    return typeExtratUmrah.filter(
      (option) => !usedDesignations.includes(option.value)
    );
  };

  const handleUpdateService = (index, serviceValue) => {
    const updatedExtrats = model.extrats.map((ext, i) =>
      i === index
        ? {
            ...ext,
            service: serviceValue,
            designation: getServiceLabel(serviceValue, ""),
          }
        : ext
    );
    setModel((prevModel) => ({ ...prevModel, extrats: updatedExtrats }));
  };

  const providersOptions = (providers) => {
    return providers.map((provider) => ({
      label: provider.name,
      value: provider.id,
    }));
  };

  const handleCostChange = (i, cost) => {
    const parsedCost = parseFloat(cost);
    if (parsedCost >= 0) {
      handleUpdateExtrat(i, "cost", parsedCost);
    }
  };

  return (
    <>
      <h6>Extrats</h6>
      {model.extrats.length === 0 ? (
        <IconButton
          onClick={handleAddExtrats}
          color="violet"
          icon={<PlusRoundIcon />}
        />
      ) : (
        <>
          <div style={styles.extratsMainContainer}>
            <div style={styles.conatainer}>
              <Responsive className="p-10" m={4} l={3} xl={2.5}>
                <label>{Translation.supplier}:</label>
                <SelectPicker
                  onSearch={fetchProviders}
                  data={providersOptions(providers)}
                  block
                  noSearch
                  value={providerId}
                  onSelect={handleProviderSelect}
                />
              </Responsive>

              <Responsive s={3} m={3} l={2.5} xl={2} className="p-10">
                <label>{Translation.currency}:</label>
                <SelectPicker
                  data={getCurrencyOptions()}
                  block
                  noSearch
                  value={currencyId}
                  onSelect={handleCurrencySelect}
                />
              </Responsive>

              <Responsive s={3} m={3} l={1.5} xl={1} className="p-10">
                <label>Cour:</label>
                <Input type="text" value={exchange} disabled />
              </Responsive>
            </div>
            {model.extrats.map((extrat, i) => (
              <div key={i} className="fee-entry" style={styles.conatainer}>
                <Responsive className="p-10" m={4} l={2.5} xl={1.8}>
                  <label>{Translation.service}:</label>
                  <SelectPicker
                    data={getAvailableExtrats(i)}
                    block
                    noSearch
                    value={extrat.service}
                    onSelect={(value) => {
                      handleUpdateService(i, value);
                    }}
                  />
                </Responsive>

                <Responsive m={4} l={3} xl={3} className="p-10">
                  <label>{Translation.designation}:</label>
                  {extrat.service === 0 ? (
                    <SelectPicker
                      data={getAvailableDesignations(i)}
                      block
                      noSearch
                      value={extrat.designation}
                      onSelect={(value) =>
                        handleUpdateExtrat(i, "designation", value)
                      }
                    />
                  ) : (
                    <Input
                      value={getServiceLabel(
                        extrat.service,
                        extrat.designation
                      )}
                      disabled
                    />
                  )}
                </Responsive>

                <Responsive s={4} m={4} l={1.5} xl={1.5} className="p-10">
                  <label>{Translation.cost}:</label>
                  <Input
                    type="number"
                    step="0.1"
                    min="0"
                    value={extrat.cost}
                    onChange={(cost) => handleCostChange(i, cost)}
                  />
                </Responsive>

                <Responsive s={4} m={4} l={1.3} xl={1.3} className="p-10">
                  <label>
                    {Translation.cost} {Translation.TND}:
                  </label>
                  <Input
                    type="text"
                    value={format_number(extrat.cost * extrat.exchange)}
                    disabled
                  />
                </Responsive>

                <Responsive s={2} m={1.6} l={1} xl={1}>
                  <div style={styles.iconButton} />
                  <IconButton
                    onClick={() => handleRemoveExtrat(i)}
                    color="violet"
                    icon={<TrashIcon />}
                  />
                  {i + 1 === model.extrats.length && (
                    <IconButton
                      onClick={handleAddExtrats}
                      color="violet"
                      icon={<PlusRoundIcon />}
                    />
                  )}
                </Responsive>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default ExtratsForm;
